import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';
import { quickVideoKeys } from './quickVideoKeys';
import { useTranslation } from 'react-i18next';

export interface ITestSendQuickVideoPart {
  videoId?: number;
  quickVideoPartId: number;
}

interface ITestSendData {
  recipientName: string;
  inventoryItemId: number;
  quickVideoParts: ITestSendQuickVideoPart[];
  quickVideoId: number;
}

export const testSend = async (body: ITestSendData) => {
  return (
    await EXPRESS_API.post(`quick-videos/${body.quickVideoId}/test-send`, body)
  ).data;
};

export const useTestSendMutation = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation(testSend, {
    onSuccess: () => {
      successToast({
        title: t(
          'Quick Video was successfully submitted and will be sent shortly.'
        ),
      });
      // invalidate
      queryClient.invalidateQueries(quickVideoKeys.all());
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: err => {
      showError(err);
    },
  });
};
